<template>
  <div v-if="loadingStatus" class="body-max-width-background-color">
    <div class="body-max-width">
      <Header title=""></Header>
    </div>

    <div class="flex-mid">
      <div
        class="fs-18 fc-000000 pt-40"
        style="margin-left: -25px; margin-right: -25px; overflow: hidden"
      >
        <div class="pt-10 center" style="width: 100%; overflow: hidden">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              height: 120%;
              object-fit: cover;
              overflow: hidden;
            "
          />
        </div>
        <div class="dialog-water">
          <div class="fs-18 fw-500 center">{{ $t("loading") }}</div>
        </div>
        <!-- <div class="center">{{ $t("loading") }}</div> -->
      </div>
    </div>
  </div>

  <div v-else class="body-max-width">
    <div v-if="!well" class="body-max-width">
      <Header back="back" :title="$t('appointmentDetIl')"></Header>
    </div>
    <div v-else class="body-max-width">
      <Header :title="$t('appointmentDetIl')"></Header>
    </div>

    <div class="appointment-card" id="appointmentCard">
      <img src="@/assets/image/appointment-card.png" />
      <div class="appointment-detail">
        <div class="show-detail">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/appointmentIcon/appointmetnNumber.png"
              />
            </div>

            <p>{{ $t("appointmentNumber") }}</p>
          </div>
          <div class="detail">
            <p>{{ appointmentCode }}</p>
          </div>
        </div>
        <div class="show-detail">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/appointmentIcon/appointmentDate.png"
              />
            </div>
            <p>{{ $t("appointmentDate") }}</p>
          </div>
          <div class="detail">
            <p>{{ appointmentDate }}</p>
          </div>
        </div>
        <div class="show-detail">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/appointmentIcon/appointmetnLocation.png"
              />
            </div>
            <p>{{ $t("appointmentLocation") }}</p>
          </div>
          <div class="detail">
            <p>{{ appointmentLocation }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="package-part">
      <div v-if="packageAmount > 1">
        <p class="package-amount">
          {{ packageAmount }} {{ $t("manyPackage") }}
        </p>
      </div>
      <div v-else>
        <p class="package-amount">{{ packageAmount }} {{ $t("package") }}</p>
      </div>
      <div
        class="package-detail-card"
        v-for="pack in appointmentPackage"
        :key="pack.packageId"
      >
        <div class="package-card-header">
          <img :src="pack.packageImage" />
          <p class="package-name flex-mid">{{ pack.packageName }}</p>
        </div>

        <div class="package-item">
          <ul>
            <li v-for="item in pack.itemList" :key="item.id">
              <p v-for="name in item" :key="name.id">{{ name }}</p>
            </li>
          </ul>
        </div>
        <div v-for="desc in pack.packageDescription" :key="desc.id">
          <p class="package-description">{{ desc }}</p>
        </div>
      </div>
      <div class="contact-box">
        <p class="contact-us">{{ $t("contactUs") }} {{ contactNumber }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import axios from "axios";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
import errorImg from "@/assets/image/36572-under-maintenance.json";
import { query } from "vue-gtag";

export default defineComponent({
  name: "AppointmentDetail",
  components: {
    Header,
  },
  setup() {
    return {
      // modules: [Mousewheel],
      packageDetail: [
        {
          packageName: "Liver Checkup แบบ Basic 8 รายการ",
          packageId: 1,
          imageUrl: "src/assets/image/Disease/cancer-pic.png",
          itemList: [
            "ตรวจสุขภาพโดยทั่วไป",
            " ตรวจความสมบูรณ์ของเม็ดเลือด CBC",
            "ตรวจวัดระดับน้ำตาลในเลือด (Fasting Blood Sugar)",
            "ตรวจระดับน้ำตาลในเลือดสะสม HbA1C",
            "ตรวจวัดระดับไขมันในเลือด (Lipid Profile)",
            "คอเลสเตอรอลรวม (Total Cholesterol)",
            "ไตรกลีเซอไรด์ (Triglyceride)",
            "คอเลสเตอรอล LDL",
            "คอเลสเตอรอล HDL",
            "ตรวจการทำงานของตับ",
            "ตรวจการทำงานของตับ ALT",
            "ตรวจการทำงานของตับ AST",
            "Alkaline Phosphatases",
            "ตรวจการทำงานของไต",
            "Creatinine plus GFR",
            "Blood Urea Nitrogen (BUN)",
            " ตรวจหาโรคเก๊าท์ (Uric Acid)",
            "ตรวจปัสสาวะ",
          ],
        },
      ],
    };
  },

  data() {
    return {
      lang: "",
      appointmentDate: "",
      appointmentId: "",
      appointmentLocation: "",
      hospitalId: "",
      appointmentPackage: [],
      pacakgeAmount: 0,
      contactNumber: "",
      loadingStatus: true,
      well: false,
    };
  },
  mounted() {
    this.channel = this.$cookies.get("channel");
    this.lang = this.$cookies.get("lang");
    this.username = this.$cookies.get("username");
    this.memberId = this.$cookies.get("memberId");
    this.$gtag.set("user_properties", {
      memberId: this.memberId,
    });
    this.accessToken = this.$cookies.get("access_token");
    this.well = this.$route.query.well ? this.$route.query.well : false;
    // get appointmentCoode from query
    this.appointmentId = this.$route.query.appointmentId;
    this.getAppointmentDetail();
    // this.getDataHospital();
  },

  methods: {
    redirect(redirect) {
      window.location.href = redirect;
    },
    getAppointmentDetail() {
      axios
        .get(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/appointment/detail",

          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
            params: {
              appointmentId: this.appointmentId,
            },
          }
        )
        .then((res) => {
          const data = res.data;
          const dateTime = new Date(data.primaryDateTime);
          const AppDate = dateTime.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });

          const AppDateTh = dateTime.toLocaleDateString("th-TH", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          if (this.lang == "th") {
            this.appointmentDate = AppDateTh;
          } else {
            this.appointmentDate = AppDate;
          }
          let appointmentPackageData = [];
          let appointmentPackageDetail = [];
          let packageData = res.data.packageDetails;
          packageData.forEach((element) => {
            appointmentPackageData.push({
              packageName: element.packageName,
              packageId: element.packageId,
              packageImage: element.packageImage,
              itemList: element.items,
              packageDescription: element.packageDescription.split("\n"),
            });
          });

          for (let i = 0; i < appointmentPackageData.length; i++) {
            let itemList = [];
            for (
              let j = 0;
              j < appointmentPackageData[i].itemList.length;
              j++
            ) {
              itemList.push(appointmentPackageData[i].itemList[j].split("\n"));
            }
            appointmentPackageData[i].itemList = itemList;
          }

          this.appointmentCode = res.data.appointmentCode;
          this.appointmentLocation = res.data.hospitalName;
          this.hospitalId = res.data.hospitalId;
          this.packageAmount = res.data.packageNumber;
          this.appointmentPackage = appointmentPackageData;
          this.getHospital();
        })
        .catch((error) => {
          this.error = error;
          window.$("#errorModal").modal("show");
        });
    },
    getHospital() {
      axios
        .get(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/hospital/get",
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
            params: {
              hospitalId: this.$route.query.hospitalId,
            },
          }
        )
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].hospitalId == this.hospitalId) {
              this.contactNumber = res.data[i].hospitalTel;
            }
          }
          this.loadingStatus = false;
        })
        .catch((error) => {
          this.error = error;
          window.$("#errorModal").modal("show");
        });
    },
  },
});
</script>

<style lang="scss" scoped>
.appointment-card {
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  border-radius: 21px;
  width: 100%;
  padding: 2rem;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;

  img {
    display: block;
    margin: auto;
  }

  .appointment-detail {
    margin: auto;
    margin-top: 2rem;
    display: block;
    // justify-content: center;
    // align-items: center;

    .show-detail {
      width: 100%;
      margin: auto;
      display: grid;
      grid-template-columns: auto auto;

      .title {
        display: flex;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        .icon {
          margin-right: 1rem;
          img {
            width: 2rem;
            height: 2rem;
          }
        }
      }

      .detail {
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        text-align: right;
      }
    }
  }
}

.package-part {
  margin-top: 2rem;

  .package-amount {
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    margin-bottom: 2rem;
  }

  .package-detail-card {
    width: 100%;
    display: block;
    border-radius: 27px;
    background: #ffffff;
    filter: drop-shadow(3px 4px 4px rgba(148, 148, 148, 0.25));

    padding: 2rem;
    margin-bottom: 2rem;
    border: 1px solid #43b422;

    .package-card-header {
      display: flex;
      margin: auto;
      width: 100%;

      img {
        height: 10rem;
        width: 12rem;
        object-fit: cover;
        border-radius: 12px;
      }

      .package-name {
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 2rem;
        // margin-top: 5rem;
        margin-left: 1rem;
      }
    }

    .package-item {
      margin-top: 1rem;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 21px;
      color: #545454;
    }

    .package-description {
      color: #ff1717;
      font-size: 1.4rem;
    }
  }
}
.contact-box {
  margin: 2rem;
  .contact-us {
    color: #ff1717;
    font-size: 1.4rem;
    font-weight: 400;
    text-align: center;
  }
}
</style>
